import * as Yup from 'yup';

import { jobOfferNominationVisible } from 'utils/countries';

import { validateField, ValidationType } from './formValidation';

/**
 * Job offer fields aligned with AssessmentV2/JobOfferForm.tsx validate():
 * - country, region, profession, hourly_wage required
 * - nomination required only while the NOI / nomination control is visible
 * - work_permit is NOT required (skipped in old validate)
 */
export const createJobOfferItemSchema = (enabled: readonly string[] | null | undefined) =>
    Yup.object({
        country: validateField(ValidationType.STRING),
        region: validateField(ValidationType.STRING),
        profession: validateField(ValidationType.STRING),
        hourly_wage: Yup.number()
            .typeError('Hourly wage is required')
            .moreThan(0, 'Hourly wage must be greater than 0')
            .required('Hourly wage is required'),
        nomination: Yup.string()
            .nullable()
            .when('country', {
                is: (country: string | null | undefined) =>
                    jobOfferNominationVisible(enabled, country),
                then: (schema) => schema.required('This is a required field'),
                otherwise: (schema) => schema.nullable(),
            }),
        work_permit: Yup.string().nullable(),
        zip: Yup.string().nullable(),
    });

export const createJobOfferValidationSchema = (enabled: readonly string[] | null | undefined) =>
    Yup.object({
        has_job_offer: Yup.boolean().nullable(),
        // Only require offer rows when the user selected Yes. When No, allow an empty list
        // without item-level validation (otherwise Yup.min(1) can fire during intermediate state).
        job_offers: Yup.array().when('has_job_offer', {
            is: true,
            then: (schema) =>
                schema
                    .of(createJobOfferItemSchema(enabled))
                    .min(1, 'At least one job offer is required when you have a job offer'),
            otherwise: () => Yup.array().notRequired(),
        }),
    });
